import revive_payload_client_YTGlmQWWT5 from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_neSs9z3UJp from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_VeD7Ba96AP from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_VTarsGAzgb from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/node_modules/nuxt/dist/app/plugins/payload.client.js";
import plugin_vue3_xKuw1km5sV from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/.nuxt/components.plugin.mjs";
import prefetch_client_8FoqvPFTot from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import i18n_dOTnCc6TUQ from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import chunk_reload_client_SeG0EjL5Ec from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import bignumber_DfGWd9BIp0 from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/plugins/bignumber.ts";
import chartjs_1wC9lAM0Tp from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/plugins/chartjs.ts";
import datadog_browser_rum_client_ORLzi7PhkC from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/plugins/datadog-browser-rum.client.ts";
import msw_client_EKy2ynTIMk from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/plugins/msw.client.ts";
import sentry_client_shVUlIjFLk from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/plugins/sentry.client.ts";
import vuetify_7h9QAQEssH from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/plugins/vuetify.ts";
export default [
  revive_payload_client_YTGlmQWWT5,
  unhead_neSs9z3UJp,
  router_VeD7Ba96AP,
  payload_client_VTarsGAzgb,
  plugin_vue3_xKuw1km5sV,
  components_plugin_KR1HBZs4kY,
  prefetch_client_8FoqvPFTot,
  i18n_dOTnCc6TUQ,
  chunk_reload_client_SeG0EjL5Ec,
  bignumber_DfGWd9BIp0,
  chartjs_1wC9lAM0Tp,
  datadog_browser_rum_client_ORLzi7PhkC,
  msw_client_EKy2ynTIMk,
  sentry_client_shVUlIjFLk,
  vuetify_7h9QAQEssH
]